module.exports = __webpack_public_path__ + "/static/assets/8c5774830e83c866d2be15afe09f5590.gif";